import Censorable from 'Components/Censorable';
import Icon from '../Icon';
import { Icons } from '../Icon/AvailableIcons';
import { useAppSelector } from 'Store/index';

const SSNWithFlag = ({ patientData, iconSize, ssnSpacing = false }: ISSNWithFlag) => {
  const orgSettings = useAppSelector(s => s.settings.orgSettings);
  // Flags are only shown when the org has more than one allowed patient country (defaultLocale null = no flags)
  const defaultLocale: string | null | undefined =
    (orgSettings.allowedPatientCountries ?? []).length > 1
      ? orgSettings.allowedPatientCountries?.find(apc => apc.isDefault)?.code
      : null;
  const ssnLocalization = patientData?.ssnLocalization;
  const showFlag =
    defaultLocale !== null && !!ssnLocalization && ssnLocalization !== defaultLocale && ssnLocalization in Icons;
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {showFlag ? (
        <div style={{ marginRight: '0.5rem' }}>
          <Icon icon={ssnLocalization} size={iconSize ?? 2} />
        </div>
      ) : (
        <></>
      )}
      <div style={{ width: ssnSpacing ? '11rem' : 'auto' }}>
        <Censorable>{patientData?.ssn}</Censorable>
      </div>
    </div>
  );
};

interface ISSNWithFlag {
  patientData?: Pick<IPatientUI, 'ssn' | 'ssnLocalization'>;
  iconSize?: number;
  /** Add spacing to the ssn string to display it evenly when displayed in a list */
  ssnSpacing?: boolean;
}

export default SSNWithFlag;
